<template>
  <div class="pa-5 pt-2">
    <v-row>
      <v-col cols="12">
        <statistics-analysis-data-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import StatisticsAnalysisDataTable from './DataTable'
export default {
  name: 'statistics-analysis',
  components: {
    StatisticsAnalysisDataTable
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?6f6348ee